import { AttendanceProcessAttendeeFailure } from '../../../../../db/classes/types';
import AttendanceProcessErrorLayout from '../AttendanceProcessErrorLayout';
import { StyledCourseUserCell, userCellClasses } from './styles';
import useAttendeeErrorVM from './vm';

interface Props {
  failure: AttendanceProcessAttendeeFailure;
}

const AttendeeError = ({ failure }: Props) => {
  const { getAttendanceErrorMessage } = useAttendeeErrorVM();

  return (
    <AttendanceProcessErrorLayout failure={failure}>
      <StyledCourseUserCell
        isCourseRoleNeeded
        existingCourseRole={failure.attendee.role}
        avatar={failure.attendee.avatar}
        subtitle={getAttendanceErrorMessage(failure.failureCode)}
        classes={{ subtitle: userCellClasses.subtitle }}
      />
    </AttendanceProcessErrorLayout>
  );
};

export default AttendeeError;
